var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78.58 47.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.26 -0.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 79.12,
    height: 47.96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-3",
    d: "M78.61,8.52l-1-.8-.43-.35A35.23,35.23,0,0,0,55.44.26,46.85,46.85,0,0,0,27.62,9.81a50.76,50.76,0,0,0-17.5,24.24V23.33a4.13,4.13,0,0,0-1.28-3,4.19,4.19,0,0,0-3-1.27H1.89a.65.65,0,0,0-.65.65V47a.65.65,0,0,0,.65.65H18.14a.63.63,0,0,0,.63-.55,54.89,54.89,0,0,1,14.3-29.82c7.61-7.87,17.24-12.2,27.12-12.2A37.34,37.34,0,0,1,77.87,9.57a.66.66,0,0,0,.86-.2.64.64,0,0,0-.12-.85ZM63.39,3.19c-1.07-.09-2.13-.14-3.21-.14-10.44,0-20.59,4.56-28.6,12.83A56.78,56.78,0,0,0,16.94,45.62H3.31V21.09H5.79a2.1,2.1,0,0,1,1.59.67,2.07,2.07,0,0,1,.67,1.57v15a1.42,1.42,0,0,0,1.24,1.41,1.41,1.41,0,0,0,1.55-1c6.65-25,27.78-36.39,44.59-36.39a35.9,35.9,0,0,1,8,.86ZM9.81,16.84v-2.7A4.28,4.28,0,0,0,8.55,11,3.81,3.81,0,0,0,5.68,9.78H.91a.66.66,0,0,0-.65.64v.37c0,1.48,0,3.72,1.45,5.21a6,6,0,0,0,4.41,1.48H9.17A.64.64,0,0,0,9.81,16.84ZM7.75,15.42H6.12a4.13,4.13,0,0,1-2.94-.87,4.06,4.06,0,0,1-.84-2.7H5.68a1.75,1.75,0,0,1,1.41.66,2.27,2.27,0,0,1,.66,1.64Z",
    transform: "translate(-0.26 -0.26)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.4bdcb207b767b4347d541af4d79744f2.svg";
export { ForwardRef as ReactComponent };